export const doesSearchMatchCastType = (castType: string, search: string) =>
  castType.toLowerCase().includes(search.toLowerCase());
